import { getAccessToken } from '../../utils/authUtils';

export default async function simpleFileUpload(
  postUrl: string,
  file: File,
  params: any = {},
) {
  const body = new FormData();
  body.append('file', file);

  if (Object.keys(params).length > 0) {
    Object.keys(params).forEach((key) => {
      body.append(key, params[key]);
    });
  }

  const res = await fetch(postUrl, {
    method: 'post',
    credentials: 'include',
    headers: {
      authorization: `Bearer ${getAccessToken()}`,
    },
    body,
  });

  const data = await res.json();

  if (res.ok) return data;
  else throw new Error(data.message);
}
